var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPrayerLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    x: "0px",
    y: "0px",
    xmlns: "http://www.w3.org/2000/svg",
    width: 512,
    height: 512,
    viewBox: "0 0 1080 1080",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M612.25,29.99v515.08l-183.2-317.31L225.84,579.71l108.41,62.6l56.16-97.27v496.08 C176.7,976.9,21,778.64,21,544C21,257.36,253.36,25,540,25C564.52,25,588.64,26.7,612.25,29.99z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1059,544c0,286.64-232.36,519-519,519c-24.54,0-48.69-1.7-72.32-4.99V545.07h0.01l183.2,317.3L854.4,509.89 L745.99,447.3l-56.47,97.8V46.86C903.27,111.05,1059,309.34,1059,544z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrayerLogo);
export default __webpack_public_path__ + "static/media/prayerLogo.abbfa7ce861f9dd854d05a271256e182.svg";
export { ForwardRef as ReactComponent };